import { userActions } from 'redux/user';
import { authTypes } from 'redux/auth';
import tokenService from 'services/tokenService';
import config from 'config';
import Echo from 'laravel-echo';
import { getCommonHeaders } from 'redux/helpers/utils';

require('pusher-js');

let echo; // Our singleton echo instance

const initEcho = token => new Echo({
  broadcaster: 'pusher',
  key: config.pusher.key,
  cluster: config.pusher.cluster,
  authEndpoint: config.pusher.authEndpoint,
  forceTLS: config.pusher.tls,
  auth: {
    headers: getCommonHeaders(token),
  },
});

const closeSocket = () => echo ? echo.disconnect() : false;

const openSocket = (user, dispatch) => {
  tokenService.getAccessToken()
    .then(token => {
      closeSocket();

      echo = initEcho(token);

      echo
        .private(`user.${user.id}`)
        .notification(() => dispatch(userActions.newNotification()));
    });
};

export default store => next => action => {

  const { type, payload } = action;

  switch (type) {
    case authTypes.getAuthUserSuccess:
      openSocket(payload.user, store.dispatch);
      break;
    case authTypes.logoutSuccess:
      closeSocket();
      break;
    default:
      break;
  }

  next(action);
};
